import { hotRanking } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

function TrendIcon({ trend }: { trend: string }) {
  if (trend === "up") {
    return <i className="ri-arrow-up-line text-primary-500"></i>;
  }
  if (trend === "down") {
    return <i className="ri-arrow-down-line text-secondary-500"></i>;
  }
  return (
    <span className="rounded-sm bg-accent-500 px-1 py-0.5 text-[10px] leading-none text-background-50">
      新
    </span>
  );
}

export default function HotRanking() {
  const half = Math.ceil(hotRanking.length / 2);
  const columns = [hotRanking.slice(0, half), hotRanking.slice(half)];

  return (
    <section className="border-b border-background-200 bg-background-100 scroll-mt-32">
      <div className="px-4 md:px-6 py-8 md:py-12">
        <SectionHeading
          id="ranking"
          index="06"
          title="吃瓜热榜"
          subtitle="按讨论量实时排序，每隔几分钟刷新一次"
          actionText="查看完整榜单"
        />

        <div className="mt-5 grid grid-cols-1 md:grid-cols-2 gap-x-8">
          {columns.map((column, columnIndex) => (
            <ol key={columnIndex} className="divide-y divide-background-200">
              {column.map((item) => (
                <li key={item.rank}>
                  <a
                    href="#ranking"
                    className="group flex items-center gap-3 py-3.5 cursor-pointer"
                  >
                    <span
                      className={`w-6 shrink-0 text-center font-heading text-base font-bold ${
                        item.rank <= 3 ? "text-primary-500" : "text-foreground-400"
                      }`}
                    >
                      {item.rank}
                    </span>
                    <span className="min-w-0 flex-1 text-sm leading-snug text-foreground-800 transition-colors group-hover:text-primary-600 hlwp-clamp-2">
                      {item.title}
                    </span>
                    <span className="shrink-0 flex items-center gap-2 text-xs text-foreground-500">
                      <span className="tabular-nums">{item.heat}</span>
                      <span className="w-4 flex justify-center">
                        <TrendIcon trend={item.trend} />
                      </span>
                    </span>
                  </a>
                </li>
              ))}
            </ol>
          ))}
        </div>
      </div>
    </section>
  );
}